module.exports = __webpack_public_path__ + "static/media/skulloids.1adc6ee3.gif";